<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('queryJob.enterSubLabel')"
    :width="$selectByLang('300px', '350px')"
    :close-on-click-modal="false"
  >
    <el-form :label-width="$selectByLang('80px', '130px')" label-position="left">
      <el-form-item :label="$t('queryJob.subLabel')+'：'">
        <el-input v-model="warehouseInForm.label" />
      </el-form-item>
      <el-form-item :label="$t('Billing.WayBillNumber')+'：'">
        {{ jobForm.mbl }}
      </el-form-item>
      <el-form-item :label="$t('Payment.warehouseNo')+'：'">
        {{ warehouseInForm.warehouseNo }}
      </el-form-item>
      <el-form-item :label="$t('queryJob.receiptNo')+'：'">
        {{ warehouseInForm.receiptNo }}
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveWarehouseInForAe } from '@/api/seaExport/warehouseIn'

export default {
  name: 'WarehouseLabelDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    warehouseIn: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      jobForm: {
        mbl: ''
      },
      warehouseInForm: {
        label: '',
        warehouseNo: '',
        receiptNo: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.jobForm.uuid !== this.job.uuid) {
          this.jobForm = { ...this.job }
        }
        if (this.warehouseInForm.uuid !== this.warehouseIn.uuid) {
          this.warehouseInForm = { ...this.warehouseIn }
        }
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    clickHandler() {
      if (!this.warehouseInForm.label) {
        this.$message.info(this.$t('queryJob.pleaseEnterSubLabel'))
        return
      }
      saveWarehouseInForAe(this.warehouseInForm).then(res => {
        this.warehouseInForm.version += 1
        Object.assign(this.warehouseIn, this.warehouseInForm)
        this.innerVisible = false
        this.$emit('callback', this.warehouseInForm.label)
      })
    }
  }
}
</script>
